import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Grow } from '@mui/material';
import UploadFileRoundedIcon from '@mui/icons-material/UploadFileRounded';
import CustomDialog from '../../../../Components/Dialog/CustomDialog';
import LoadingFilesWidget from './LoadingFilesWidget';

const LoadDialog = function LoadDialog({
  open = false,
  onClose = () => {},
  sections = [],
  campaigns = [],
  reloadHistory = () => {},
}) {
  const intl = useIntl();

  return (
    <CustomDialog
      id="load-dialog"
      maxWidth="sm"
      fullWidth
      showOnly
      disableActions
      open={open}
      noBackdrop
      close={onClose}
      transition={Grow}
      title={intl.formatMessage({ id: 'LOADING_FILES' })}
      icon={<UploadFileRoundedIcon />}
    >
      <LoadingFilesWidget
        sections={sections}
        campaigns={campaigns}
        closeDialog={onClose}
        reloadHistory={reloadHistory}
      />
    </CustomDialog>
  );
};

LoadDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sections: PropTypes.array,
  reloadHistory: PropTypes.func,
};

export default LoadDialog;
